import React, { useState } from 'react';
import { Scissors, CheckCircle2, ArrowRight } from 'lucide-react';
export function CouponSection() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <section id="coupon" className="py-20 px-4 bg-gradient-to-br from-sky-50 to-white relative overflow-hidden" data-id="element-17" data-mp="3jvjagnosbifa">
      {/* Decorative background blobs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-sky-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-x-1/2 -translate-y-1/2" data-id="element-18" data-mp="3nzh8sw6acp7a" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#b87333]/10 rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-x-1/2 translate-y-1/2" data-id="element-19" data-mp="1r7ubuxwu5w6" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-20" data-mp="23ht75j5hoy6p">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-21" data-mp="23jdy6yslhyzt">
          {/* LEFT: Visual Coupon */}
          <div className="relative group" data-id="element-22" data-mp="28ih40lgeg98u">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#b87333] to-amber-400 rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-1000 group-hover:duration-200" data-id="element-23" data-mp="3h736jt6lpedp" />
            <div className="relative bg-white border-2 border-dashed border-[#b87333] rounded-2xl p-8 sm:p-10 shadow-xl overflow-hidden" data-id="element-24" data-mp="37g8hyi5vu2p3">
              <Scissors className="absolute top-4 right-4 w-6 h-6 text-[#b87333]/40 -rotate-90" data-id="element-25" data-mp="32jqcth6n42c8" />

              <div className="text-center space-y-4" data-id="element-26" data-mp="3zi4ji7z0ndd">
                <div className="inline-block bg-[#0c2340] text-white px-4 py-1 rounded-full text-sm font-bold tracking-wider mb-2" data-id="element-27" data-mp="3v6b4yjuxwigu">
                  SPECIAL OFFER
                </div>
                <h3 className="text-5xl sm:text-6xl font-black text-[#b87333] tracking-tight" data-id="element-28" data-mp="3m666iz7q4uet">
                  $50 OFF
                </h3>
                <p className="text-xl sm:text-2xl font-bold text-[#0c2340]" data-id="element-29" data-mp="2etw2p7dpgrvo">
                  Your First Gutter Service
                </p>
                <div className="pt-6 pb-4" data-id="element-30" data-mp="2c7wqxh2qsb5j">
                  <div className="bg-slate-50 border border-slate-200 rounded-lg py-3 px-6 inline-block" data-id="element-31" data-mp="2c8y0fh440pl5">
                    <span className="text-slate-500 text-sm uppercase tracking-wider block mb-1" data-id="element-32" data-mp="2h5oksgmy67cd">
                      Use Code
                    </span>
                    <span className="text-2xl font-mono font-bold text-slate-800 tracking-widest" data-id="element-33" data-mp="278juq5pzdrqa">
                      AFLOW50
                    </span>
                  </div>
                </div>
                <p className="text-sm text-slate-400" data-id="element-34" data-mp="1y7vgb9wodpcv">
                  Valid for new customers only. Expires 12/31/2025. Cannot be
                  combined with other offers.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT: Lead Capture Form */}
          <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8 sm:p-10" data-id="element-35" data-mp="1aiszg49v80jf">
            {isSubmitted ? <div className="text-center py-12 space-y-4 animate-in fade-in zoom-in duration-500" data-id="element-36" data-mp="1ekearl6r46ri">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-37" data-mp="vwvm6mnbm8qn">
                  <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-38" data-mp="qy2ghge9zm11" />
                </div>
                <h3 className="text-3xl font-bold text-[#0c2340]" data-id="element-39" data-mp="14xbnpqki75sv">
                  Coupon Sent!
                </h3>
                <p className="text-lg text-slate-600" data-id="element-40" data-mp="zw4ero6mk0km">
                  Check your email for your $50 off coupon code. We look forward
                  to serving you!
                </p>
              </div> : <>
                <div className="mb-8" data-id="element-41" data-mp="1nmryd6pwken0">
                  <h3 className="text-3xl font-bold text-[#0c2340] mb-3" data-id="element-42" data-mp="1nlqgojedstwb">
                    Claim Your $50 Coupon
                  </h3>
                  <p className="text-slate-600 text-lg" data-id="element-43" data-mp="1jnsqbd8vk1rc">
                    Enter your details below and we'll email your discount code
                    instantly.
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-5" data-id="element-44" data-mp="2coha973mrnov">
                  <div data-id="element-45" data-mp="2cm4wz78ti1i5">
                    <label htmlFor="coupon-name" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-46" data-mp="2gpt0neubwcy4">
                      Full Name
                    </label>
                    <input type="text" id="coupon-name" required className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow bg-slate-50 focus:bg-white" placeholder="John Doe" data-id="element-47" data-mp="2qekpvf808j5c" />
                  </div>
                  <div data-id="element-48" data-mp="27qpjigeq27m9">
                    <label htmlFor="coupon-email" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-49" data-mp="27mryfp8l35zq">
                      Email Address
                    </label>
                    <input type="email" id="coupon-email" required className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow bg-slate-50 focus:bg-white" placeholder="john@example.com" data-id="element-50" data-mp="17h7p8nkapaex" />
                  </div>
                  <div data-id="element-51" data-mp="os1d5je0bh23">
                    <label htmlFor="coupon-phone" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-52" data-mp="oo3s2s7vcffk">
                      Phone Number (Optional)
                    </label>
                    <input type="tel" id="coupon-phone" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow bg-slate-50 focus:bg-white" placeholder="(714) 555-0123" data-id="element-53" data-mp="9tz5oy3uubfk" />
                  </div>

                  <button type="submit" className="w-full flex items-center justify-center gap-2 bg-[#b87333] hover:bg-[#a0632a] text-white font-bold py-4 px-8 rounded-lg transition-colors shadow-lg shadow-[#b87333]/20 mt-4" data-id="element-54" data-mp="791cdxc8ljh6">
                    Send My Coupon
                    <ArrowRight className="w-5 h-5" data-id="element-55" data-mp="l929r2tam8rw" />
                  </button>
                  <p className="text-xs text-center text-slate-400 mt-4" data-id="element-56" data-mp="q6kl0zus9032">
                    By submitting this form, you agree to receive emails from
                    A-Flow. No spam, unsubscribe anytime.
                  </p>
                </form>
              </>}
          </div>
        </div>
      </div>
    </section>;
}